import { render, staticRenderFns } from "./own-space.vue?vue&type=template&id=62f6247c&scoped=true"
import script from "./own-space.vue?vue&type=script&lang=js"
export * from "./own-space.vue?vue&type=script&lang=js"
import style0 from "./own-space.vue?vue&type=style&index=0&id=62f6247c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f6247c",
  null
  
)

export default component.exports